export class ChartData {
    data: number[] = [];
    label: string;
}
